import ModalRedux from './ModalRedux.view';

export default ModalRedux;
